

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import { UserSkillsWrapper } from '../models/skills/userskillwrapper';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { UserSkill } from '../models/skills/skills';
import { SkillType } from '../models/userdata/skilltype';
import { CompanySkill } from '../models/skills/companyskills';
import Paginate from 'vuejs-paginate';
import { SkillResponse } from '../models/skills/skillresponse';
import { VerticalSkillRespose } from '../models/skills/VerticalSkillRespose';
import { BFormFile } from 'bootstrap-vue/es/components';
import { UserAttribute } from '../models/skills/userattribute';
import { SkillDocWrapper } from '../models/skills/skilldocwrapper';
import { DocumentPayload } from '../models/skills/documentpayload';
import { UserAttrSkillWrapper } from '../models/skills/userattrskillwrapper';
import { SkillDocument } from '../models/skills/skilldocument';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
Vue.component('paginate', Paginate);
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { DocumentResponse } from '../models/skills/documentresponse';
import { SpinnerPlugin } from 'bootstrap-vue/es/components';
import Loader from './Loader.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import SkillCard from '@/components/Commons/SkillCard.vue';
import moment from 'moment';
import DisciplineCustomField from './MyProfile/DisciplineCustomField.vue';
import { CustomFields } from '@/models/userdata/customfields';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

declare var window:any;
@Component({
  name: 'SkillDetails',
  components: {
    Datepicker,
    Loader,
    SkillCard,
    ProfilePlaceholder,
    DisciplineCustomField,
  },
})
export default class SkillDetails extends Mixins(GuidedSignupUtilities) {
  $refs: any;
  $moment: any;
  private userProfile: UserProfile = new UserProfile();
  private companySkills: SkillResponse[] = [];
  private documentPayload: DocumentPayload = new DocumentPayload();
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private currentPageTop: number = 1;
  private recsPerPageTop: number = 5;
  private selectedIndex: number = -1;
  private selectedSkillId: number = -1;
  private bFormFiles: any[] = [];
  public tempSkillTypes: SkillDocWrapper[] = [];
  $wlToastr: any;
  private editSkills: boolean = false;
  private expandAll: boolean = false;
  private searchSkill: string = '';
  private filteredCompanySkills: SkillResponse[] = [];
  private companyVerticalSkills: VerticalSkillRespose[] = [];
  private filteredCompanyVerticalSkills: VerticalSkillRespose[] = [];
  private expandCurrent: boolean = false;
  private displayVerticalArr: String[] = [];
  private selectedUploadSkillAttr: string = '';
  private skillDocumentUploaded: string = '';
  private userAttrSkillWrappers: UserAttrSkillWrapper[] = [];
  private selectedSkills: number[] = [];
  public userFileAttributeDoc: any;
  private startDate: any;
  private skillDocument: SkillDocument = new SkillDocument();
  private skillSearchUploadDocument: SkillDocument = new SkillDocument();
  private replaceSelectedAttributeId: number = -1;
  private selectedSkill: SkillResponse = new SkillResponse();
  private selectedUserAttribute: UserAttribute = new UserAttribute();
  private selectedUserAttrSkillWrapper: UserAttrSkillWrapper =
    new UserAttrSkillWrapper();
  private documentDoesNotExpire: boolean = false;
  private skipSkillAttribute: String = '';
  private skipSkillAttributes: String[] = [];
  private documentDoesNotExpireEdit: boolean = true;
  private replaceUploadedDocument: boolean = false;
  private replaceUploadedDocumentEdit: boolean = false;
  private effectiveDateStr: string = '';
  private showModal: boolean = false;
  private showModalEdit: boolean = false;
  private showModalXS: boolean = false;
  private uploadDocument: boolean = false;
  private selectedDocument: DocumentResponse = new DocumentResponse();
  private editMode: boolean = false;
  private editDeleteHeader: string = '';
  private editDeleteBody: string = '';
  private skillDocLicenceState: string = '';
  private skillDocLicenceNumber: string = '';
  private supportedFileSize = 0;
  private isDropBoxFileUploaded: boolean = false;
  private dropBoxFile?: string;
  private dropBoxFileName?: string;
  private isCustomFieldsDataPresent: boolean = false;
  private isDisiciplineSelected: boolean = false;
  private isDisciplineMetaDataPresent: boolean = false;

  private effectiveDTTMFlag: boolean = false;
  private expiryDTTMFlag: boolean = false;
  private licenseNumberFlag: boolean = false;
  private licenseStateFlag: boolean = false;

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  @Watch('skills')
  skillListingUpdated(newList, oldList) {
    if (this.isDisciplineMetaDataPresent) {
      this.$emit(
        'disable-next-button',
        this.minimumEntries >= 0 ? (this.isRequiredStep ?  newList.length < this.minimumEntries || this.isDisiciplineSelected : this.isRequiredStep) 
        : (!newList.length || !this.isDisiciplineSelected),
      );
    } else {
      this.$emit('disable-next-button', this.minimumEntries >= 0 ? (this.isRequiredStep ?  newList.length < this.minimumEntries : this.isRequiredStep) : !newList.length);
    }
  }

  onDisciplineSelect(isSelected) {
    this.isDisiciplineSelected = isSelected;
    this.$emit('disable-next-button', !this.skills.length || !isSelected);
  }

  get skillSectionPlaceholder() {
    if (!vxm.configs.SkillSectionTitle)
      return this.$t('skillcard-search-skill-placeholder');
    const skillsTitle = vxm.configs.SkillSectionTitle || 'Skills/Specialties';
    const skillsPlaceholder = 'Search ' + skillsTitle;
    return skillsPlaceholder;
  }

  get canShowLicenceInfo() {
    return (
      vxm.configs.getGlobalConfigValue('SKILL_DOCUMENT_LICENCE_INFO') &&
      !vxm.configs.getGlobalConfigValue('TURN_ON_CREDENTIALING')
    );
  }

  get isCredentialingEnabled() {
    return vxm.configs.getGlobalConfigValue('TURN_ON_CREDENTIALING');
  }

  get documentExpires() {
    return (
      !this.documentDoesNotExpire &&
      !vxm.configs.getGlobalConfigValue('TURN_ON_CREDENTIALING')
    );
  }

  get showSkillDocumentsSection() {
    return !vxm.configs.getGlobalConfigValue(
      'HIDE_SUPPORTING_DOCUMENTS_FROM_SKILL_DETAILS',
    );
  }
  get sectionSubHeader(){
    if( this.minimumEntries>1 && this.userPermissionConfig('edit')){
      return `You need to seelct at least ${
          this.minimumEntries
        } Skills`
    }
   return ''
 }
 get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }
  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'SKILLS');
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isGuidedSignupPage() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('guidedsignup'));
    return str.includes('guidedsignup');
  }

  get sIndex() {
    return this.selectedIndex;
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download resume');
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'Resume';

      // Trigger a click event to initiate the download
      link.click();

      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }
  get pageCount() {
    const skillResponses = vxm.skills.CompanySkillWrapper.skillResponses;
    const pageCount = skillResponses != null ? skillResponses.length : 0;
    return Math.ceil(pageCount / this.recsPerPage);
  }

  get pageCountTop() {
    const skillResponses = this.userProfile.skillTypes;
    const pageCount = skillResponses != null ? skillResponses.length : 0;
    return Math.ceil(pageCount / this.recsPerPage);
  }

  get isShowSpinner() {
    // return vxm.users.isLoadingProfile;
    //return (vxm.utility.spinnerStatus || vxm.users.isLoadingProfile);
    console.log(
      'vxm.utility.spinnerStatus:' +
        vxm.utility.spinnerStatus +
        ' vxm.users.isLoadingProfile:' +
        vxm.users.isLoadingProfile,
    );
    return vxm.users.isLoadingProfile;
  }

  toggleDocumentDoesNotExpire() {
    this.documentDoesNotExpire = !this.documentDoesNotExpire;
  }

  toggleDocumentDoesNotExpireEdit() {
    this.documentDoesNotExpireEdit = !this.documentDoesNotExpireEdit;
  }

  setSelectedUploadSkillAttr(selectedUserAttribute: string) {
    this.selectedUploadSkillAttr = selectedUserAttribute;
  }

  hideUploadSkillAttr(selectedUserAttribute: string) {
    return this.selectedUploadSkillAttr == selectedUserAttribute;
  }

  setSkillDocumentUploaded(selectedUserAttribute: string) {
    this.skillDocumentUploaded = selectedUserAttribute;
  }

  hideSkillDocumentUploaded(selectedUserAttribute: string) {
    return this.skillDocumentUploaded == selectedUserAttribute;
  }

  checkDoc(file: any) {
    setTimeout(() => {
      console.log(this.bFormFiles);
    }, 500);
  }

  get skillSelectedSuccessmessageTitle() {
    if (vxm.configs.SkillSectionTitle) {
      return `${vxm.configs.SkillSectionTitle}`;
    }
    return this.$t('skill.success.message.title');
  }

  get skillSelectedSuccessmessage() {
    if (vxm.configs.SkillSectionTitle) {
      return `${vxm.configs.SkillSectionTitle} Selected Successfully`;
    }
    return this.$t('skill.success.message');
  }

  get noSkillsSpecialtyHeaderText() {
    if (vxm.configs.SkillSectionTitle) {
      return `No ${this.isDisciplineMetaDataPresent ? 'Discipline/' : ''}${
        vxm.configs.SkillSectionTitle
      } Added Yet`;
    }
    return this.$t('skills.button.header.text');
  }

  get addSkillsSpecialtySubHeaderText() {
    if (vxm.configs.SkillSectionTitle) {
      return `Please Add ${
        this.isDisciplineMetaDataPresent ? 'Discipline/' : ''
      }${vxm.configs.SkillSectionTitle} To Your Profile`;
    }
    return this.$t('skills.button.sub.header.text');
  }

  get addNewSkillsSpecialtyText() {
    if (vxm.configs.SkillSectionTitle) {
      return `Add New ${vxm.configs.SkillSectionTitle}`;
    }
    return this.$t('skills.label.addnewskills');
  }

  get addSkillsSpecialtyText() {
    if (vxm.configs.SkillSectionTitle) {
      return `Add ${this.isDisciplineMetaDataPresent ? 'Discipline & ' : ''}${
        vxm.configs.SkillSectionTitle
      }`;
    }
    return this.$t('skills.button.addkills');
  }

  get currentSkillsSpecialtyText() {
    if (vxm.configs.SkillSectionTitle) {
      return `Current ${vxm.configs.SkillSectionTitle}`;
    }
    return this.$t('skills.label.currentkills');
  }

  get editSkillsSpecialtyText() {
    if (vxm.configs.SkillSectionTitle) {
      return `Edit ${this.isDisciplineMetaDataPresent ? 'Discipline & ' : ''}${
        vxm.configs.SkillSectionTitle
      }`;
    }
    return this.$t('skills.button.editskills');
  }

  getDocumentCount(skillTypeId: number): number {
    const filteredSkillRespList =
      vxm.skills.CompanySkillWrapper.skillResponses.filter((doc) => {
        return doc.skillTypeId === skillTypeId;
      });
    if (Array.isArray(filteredSkillRespList) && filteredSkillRespList.length) {
      return filteredSkillRespList[0].userAttributes.length;
    }
    return 0;
  }

  getDocuments(skillTypeId: number): UserAttribute[] {
    const documents = vxm.skills.CompanySkillWrapper.skillResponses.filter(
      (doc) => {
        return doc.skillTypeId === skillTypeId;
      },
    )[0].userAttributes;
    return documents;
  }

  getDocumentsFlagged(sdw: SkillDocWrapper): UserAttribute[] {
    const docs = this.getDocuments(sdw.skillType.skillTypeId);
    docs.forEach((doc) => {
      const idx = sdw.documentList.findIndex((rec) => {
        return rec.userAttributeId === doc.userAttributeID;
      });

      if (idx >= 0) {
        doc.isPresent = true;
      } else {
        doc.isPresent = false;
      }
    });
    return docs;
  }
  isVerticalExists(verticalName: String): boolean {
    return this.displayVerticalArr.includes(verticalName.toLowerCase());
  }

  addVertical(verticalName: String) {
    var obj = this.VerticalSearchedSkills.find(
      (o) => o.verticalName === verticalName,
    );
    if (obj) {
      obj.skillResponses.sort((a, b) => {
        let fa = a.skillTypeName
            ? a.skillTypeName.toLowerCase()
            : a.skillTypeName,
          fb = b.skillTypeName
            ? b.skillTypeName.toLowerCase()
            : b.skillTypeName;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }
    this.displayVerticalArr.push(verticalName.toLowerCase());
  }

  removeVertical(verticalName: String) {
    const filteredVerticals = this.displayVerticalArr.filter((doc) => {
      return doc.toLowerCase() != verticalName.toLowerCase();
    });
    this.displayVerticalArr = filteredVerticals;
  }

  clearDisplayVerticalArr() {
    this.displayVerticalArr = [];
  }

  addAllVerticals() {
    this.displayVerticalArr = [];
    vxm.skills.CompanySkillWrapper.verticalSkillResposes.forEach((value) => {
      this.displayVerticalArr.push(value.verticalName.toLowerCase());
    });
  }

  toggleIndex(idx: number, skillTypeId: number) {
    if (this.selectedIndex === -1) {
      this.selectedIndex = this.getIndex(idx);
    } else {
      this.selectedIndex = -1;
    }
    console.log(this.selectedIndex);
  }

  getIndex(idx: number): number {
    return (
      this.recsPerPageTop * this.currentPageTop - this.recsPerPageTop + idx
    );
  }

  clickCallback(page) {
    this.currentPage = page;
  }

  clickCallbackTop(pageTop) {
    this.currentPageTop = pageTop;
  }

  get skills(): SkillDocWrapper[] {
    if (this.userProfile.skillTypes === null) {
      return [];
    }
    return this.userProfile.skillTypes;
  }

  async activateSkill(skill: SkillType) {
    const sdw = new SkillDocWrapper();
    if (!this.skillExist(skill)) {
      sdw.skillType.skillTypeId = skill.skillTypeId;
      sdw.skillType.skillTypeName = skill.skillTypeName;
      console.log('skill.skillTypeDescription:' + skill.skillTypeDescription);
      sdw.skillType.skillTypeDescription = skill.skillTypeDescription;
      sdw.skillType.createdDTTM = new Date(skill.createdDTTM);
      sdw.skillType.updateDTTM = new Date(skill.updateDTTM);
      sdw.skillType.locale = skill.locale;
      sdw.skillType.status = skill.status;
      if (this.userProfile.skillTypes == null) {
        this.tempSkillTypes.push(sdw);
        this.userProfile.skillTypes = this.tempSkillTypes;
      } else {
        this.userProfile.skillTypes.push(sdw);
      }
      const vm = this;
      const respPromise: any = vxm.users.addSkillsToUserProfile(vm.userProfile);
      try {
        const resp = await respPromise;
        if (resp.success) {
          vxm.users.Rudderstack.trackEvent("Skills Updated", {skillAdded : skill.skillTypeName})
          vm.$wlToastr(
            'success',
            vm.skillSelectedSuccessmessage,
            vm.skillSelectedSuccessmessageTitle,
          );
          const respPromise1: any = await vxm.skills.activateSkill(
            skill.skillTypeId,
          );
          const resp = await respPromise1;
          if (resp.success) {
            vxm.users.getProfileStrength();
          }
        } else {
          vm.$wlToastr('error', vm.$t('skill-selection-error-message'), vm.$t('skill.success.message.title'));
        }
      } catch (e) {
        let message = this.$t('myprofile-update-error');
        if (
          e &&
          e.response.data &&
          e.response.data.meta &&
          e.response.data.meta.error &&
          e.response.data.meta.error.detailedMessage
        ) {
          message = e.response.data.meta.error.detailedMessage;
        }
        this.$wlToastr('error', message, this.$t('skill.success.message.title'));
      }
    } else {
      this.$wlToastr('error', this.$t('skill-already-selected-message'), this.$t('skill.success.message.title'));
    }
  }

  skillExist(skill: SkillType): boolean {
    const existingSkillTypes = this.userProfile.skillTypes;
    if (existingSkillTypes != null) {
      return existingSkillTypes.some(
        (existingSkillType) =>
          existingSkillType.skillType.skillTypeId === skill.skillTypeId,
      );
    }
    return false;
  }

  async mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    await vxm.skills.getCompanySkillsAndAttachments();
    await vxm.users.updatedUserProfile();
    await vxm.users.getSkills();

    // Get credential definition only if credentialing id enabled
    if (this.isCredentialingEnabled) {
      await vxm.skills.getValidCredentials();
    }

    this.userProfile = vxm.users.myUserProfile;
    this.companySkills = vxm.skills.CompanySkillWrapper.skillResponses;
    this.filteredCompanySkills = vxm.skills.CompanySkillWrapper.skillResponses;
    this.companyVerticalSkills =
      vxm.skills.CompanySkillWrapper.verticalSkillResposes;
    this.filteredCompanyVerticalSkills =
      vxm.skills.CompanySkillWrapper.verticalSkillResposes;
    this.userAttrSkillWrappers = this.userProfile.userAttributeSkills;
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    console.log('user attribute skills:' + this.userAttrSkillWrappers.length);
    const customFields = vxm.users.UserCustomMetaData;
    if (
      customFields &&
      !this.lodash.isEmpty(customFields.candidateCustomMetaData)
    ) {
      const disciplineMetaData = customFields.candidateCustomMetaData.filter(
        (item) => item.label === 'Discipline',
      )[0];
      if (!this.lodash.isEmpty(disciplineMetaData)) {
        this.isCustomFieldsDataPresent =
          disciplineMetaData && disciplineMetaData.defaultValue ? true : false;
        this.isDisciplineMetaDataPresent = true;
        this.$emit('disable-next-button', this.minimumEntries >= 0 ? this.isRequiredStep : true);
      }
    }
  }

  onNextStep() {
    this.$emit('go-to-next');
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  saveUserProfile() {
    vxm.users.saveUserProfile({
      userProfile: this.userProfile,
      isPartofRegistration: false,
    });
  }

  get AvailableSkills(): SkillResponse[] {
    return vxm.skills.CompanySkillWrapper.skillResponses;
  }

  saveChanges() {
    console.log(this.userProfile);
    this.saveUserProfile();
  }

  editSavedSkills() {
    this.editSkills = true;
    this.expandAll = false;

    const customFields = vxm.users.UserCustomMetaData;
    if (
      customFields &&
      !this.lodash.isEmpty(customFields.candidateCustomMetaData)
    ) {
      this.isCustomFieldsDataPresent = true;
    }

    this.skipSkillAttributes = [];
    this.filteredCompanyVerticalSkills =
      vxm.skills.CompanySkillWrapper.verticalSkillResposes;
    this.clearDisplayVerticalArr();
  }

  saveEditedSkills() {
    this.editSkills = false;
  }

  collapseAllMenu() {
    this.expandAll = false;
    this.clearDisplayVerticalArr();
  }

  openAllMenu() {
    this.expandAll = true;
    this.addAllVerticals();
  }

  toggleExpandCurrent() {
    this.expandCurrent = !this.expandCurrent;
  }
  getSeachedSkill(searchVal: string) {
    this.skipSkillAttributes = [];
    if (searchVal == '') this.collapseAllMenu();
    else this.openAllMenu();

    this.filteredCompanyVerticalSkills = [];
    vxm.skills.CompanySkillWrapper.verticalSkillResposes.forEach((value) => {
      const filteredSkills = value.skillResponses.filter((doc) => {
        let index = doc.skillTypeName
          .toLowerCase()
          .search(searchVal.toLowerCase());
        if (index >= 0) {
          return doc.skillTypeName.toLowerCase();
        } else {
          return null;
        }
      });
      var testObj = new VerticalSkillRespose();
      testObj.skillResponses = filteredSkills;
      testObj.verticalName = value.verticalName;
      this.filteredCompanyVerticalSkills.push(testObj);
    });
  }

  get SearchedSkills(): SkillResponse[] {
    return this.filteredCompanySkills;
  }

  get VerticalSearchedSkills(): VerticalSkillRespose[] {
    return this.filteredCompanyVerticalSkills;
  }

  checkUserAttrDoc(file: any) {
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
    this.isDropBoxFileUploaded = false;
    setTimeout(() => {
      console.log(this.skillDocument.userAttrDoc);
    }, 500);
  }

  checkUserAttrDocEdit(file: any) {
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
    this.isDropBoxFileUploaded = false;
    setTimeout(() => {
      console.log(this.skillSearchUploadDocument.userAttrDoc);
    }, 500);
  }

  isUserAttrbiuteUploaded(val: DocumentResponse): boolean {
    if (val !== null) {
      return true;
    } else {
      return false;
    }
  }

  isAttrbiuteUploadedforuserAttrSkillWrapper(
    val: UserAttrSkillWrapper,
  ): boolean {
    if (val == null) return false;
    const selectedWrapper = this.userProfile.userAttributeSkills.filter(
      (doc) => {
        return (
          doc.userAttribute.userAttributeID == val.userAttribute.userAttributeID
        );
      },
    )[0];
    if (
      selectedWrapper === undefined ||
      selectedWrapper.documentResponse === undefined
    ) {
      return false;
    } else {
      if (selectedWrapper.documentResponse !== null) return true;
      else return false;
    }
  }

  getUploadedDoc(val: UserAttrSkillWrapper): String {
    const selectedWrapper = this.userProfile.userAttributeSkills.filter(
      (doc) => {
        return (
          doc.userAttribute.userAttributeID == val.userAttribute.userAttributeID
        );
      },
    )[0];
    if (
      selectedWrapper === undefined ||
      selectedWrapper.documentResponse === undefined
    ) {
      return '';
    } else {
      if (selectedWrapper.documentResponse !== null)
        return selectedWrapper.documentResponse.docGUID;
      else return '';
    }
  }

  ShowSkillDoc(fulldocPath: string) {
    const docLink =
      vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_CONTEXT_URL') +
      fulldocPath;
    window.open(docLink);
  }

  isUserAttributeUploadedForSkill(
    skillTypeId: number,
    userAttributeID: number,
  ): boolean {
    if (skillTypeId && userAttributeID) {
      const docArray = this.getUploadedDocumentList(
        skillTypeId,
        userAttributeID,
      );
      if (docArray !== null && docArray.length > 0) {
        // console.log('skillTypeId:'+skillTypeId+' userAttributeId:'+userAttributeID+'docArray:'+docArray+' returning true');
        return true;
      }
    }
    return false;
  }

  getUploadedDocumentList(
    skillTypeId: number,
    userAttributeID: number,
  ): DocumentResponse[] {
    const existingSkillTypes = this.userProfile.skillTypes.filter((doc) => {
      return doc.skillType.skillTypeId == skillTypeId;
    });
    const existingSkillType = existingSkillTypes[0];
    if (null == existingSkillType.documentList) {
      return new DocumentResponse[0]();
    }
    const docList = existingSkillType.documentList.filter((doc) => {
      return doc.userAttributeId == userAttributeID;
    });
    console.log(
      'skilltypeid:' +
        skillTypeId +
        ' userAttributeId:' +
        userAttributeID +
        ' doclist size:' +
        docList.length,
    );
    return docList;
  }

  getUploadedDocument(
    skillTypeId: number,
    userAttributeID: number,
  ): DocumentResponse {
    const docArray = this.getUploadedDocumentList(skillTypeId, userAttributeID);
    if (docArray != null && docArray.length > 0) return docArray[0];
    else return new DocumentResponse();
  }

  checkUserAttrDocForSkill(file: any) {
    setTimeout(() => {
      console.log(this.skillSearchUploadDocument.userAttrDoc);
    }, 500);
  }

  showReplaceSelectedAttribute(val: number): boolean {
    if (this.replaceSelectedAttributeId == val) {
      return true;
    } else {
      return false;
    }
  }
  replaceSelectedDoc(val: number) {
    this.replaceSelectedAttributeId = val;
  }

  showDocumentsPopUp(val: SkillResponse, userAttribute: UserAttribute) {
    this.selectedSkill = val;
    this.selectedUserAttribute = userAttribute;
    this.replaceUploadedDocumentEdit = false;
    this.skillDocument = new SkillDocument();
    this.showModalEdit = true;
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'SKILLS',
      );
      return section ? section.displayName : 'Skills/Specialties';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'SKILLS',
    );
    return section ? section.displayName : 'Skills/Specialties';
  }

  //Edit page upload
  showUploadDocument(userAttribute: UserAttribute) {
    const skillWrapperArr = this.userProfile.userAttributeSkills.filter(
      (doc) => {
        return (
          doc.userAttribute.userAttributeID == userAttribute.userAttributeID
        );
      },
    );
    this.selectUserAttrSkilllWrapper(skillWrapperArr[0]);
  }

  //Landing page upload
  selectUserAttrSkilllWrapper(val: UserAttrSkillWrapper) {
    this.selectedUserAttrSkillWrapper = val;
    this.skillDocument = new SkillDocument();

    // Get flags
    if (this.isCredentialingEnabled) {
      let credential = vxm.skills.getCredentialList.find(
        (x) => x.userAttributeMasterId == val.userAttribute.userAttributeID,
      );
      this.effectiveDTTMFlag =
        credential != null && credential.effectiveDTTMFlag;
      this.expiryDTTMFlag = credential != null && credential.expiryDTTMFlag;
      this.licenseNumberFlag =
        credential != null && credential.licenseNumberFlag;
      this.licenseStateFlag = credential != null && credential.licenseStateFlag;
    }

    // this.showModal = true;
    this.uploadDocument = true;
    this.editMode = false;
    this.documentDoesNotExpire = false;
    this.skillDocLicenceState = '';
    this.skillDocLicenceNumber = '';
  }
  //Landing page edit
  editUserAttrDocument(val: UserAttrSkillWrapper, doc: DocumentResponse) {
    this.selectedUserAttrSkillWrapper = val;
    this.skillDocument = new SkillDocument();
    this.selectedDocument = doc;
    this.uploadDocument = true;
    this.editMode = true;
    this.skillDocLicenceState = doc.licenseState;
    this.skillDocLicenceNumber = doc.licenseNumber;
    if (doc.effectiveDTTM !== null) {
      this.skillDocument.effetiveDTTM = new Date(doc.effectiveDTTM).getTime();
      this.skillDocument.effectiveDTTMText = this.$moment(
        doc.effectiveDTTM,
      ).format('YYYY-MM-DD');
    }
    if (doc.expiryDTTM !== null) {
      this.skillDocument.expiryDTTM = new Date(doc.expiryDTTM).getTime();
      this.skillDocument.expiryDTTMText = this.$moment(doc.expiryDTTM).format(
        'YYYY-MM-DD',
      );
    }
    if (doc.effectiveDTTM != null && doc.expiryDTTM == null) {
      this.documentDoesNotExpire = true;
    }
  }
  //Edit page edit
  editUploadedDocument(userAttribute: UserAttribute, doc: DocumentResponse) {
    this.userAttrSkillWrappers = this.userProfile.userAttributeSkills;
    const skillWrapperArr = this.userAttrSkillWrappers.filter((doc) => {
      return doc.userAttribute.userAttributeID == userAttribute.userAttributeID;
    });
    this.editUserAttrDocument(skillWrapperArr[0], doc);
  }

  selectUserAttrSkilllWrapperMobile(val: UserAttrSkillWrapper) {
    this.selectedUserAttrSkillWrapper = val;
    this.skillDocument = new SkillDocument();
    this.showModalXS = true;
  }

  editUserAttrSkilllWrapper(val: UserAttrSkillWrapper) {
    this.replaceUploadedDocument = false;
    this.selectedUserAttrSkillWrapper = val;
    if (val !== null) {
      if (
        val.documentResponse !== null &&
        val.documentResponse.effectiveDTTM !== null
      ) {
        this.skillDocument.effetiveDTTM = new Date(
          val.documentResponse.effectiveDTTM,
        ).getTime();
        this.skillDocument.effectiveDTTMText = new Date(
          val.documentResponse.effectiveDTTM,
        )
          .toISOString()
          .split('T')[0];
      }
      if (
        val.documentResponse !== null &&
        val.documentResponse.expiryDTTM !== null
      ) {
        this.skillDocument.expiryDTTM = new Date(
          val.documentResponse.expiryDTTM,
        ).getTime();
        this.skillDocument.expiryDTTMText = new Date(
          val.documentResponse.expiryDTTM,
        )
          .toISOString()
          .split('T')[0];
      }
    }
    this.showModal = true;
  }

  setSkipSkillAttribute(skillAttribute: String) {
    this.skipSkillAttributes.push(skillAttribute);
  }

  hideSkillAttribute(skillAttribute: String): boolean {
    return this.skipSkillAttributes.includes(skillAttribute);
  }

  async deleteSkillAttribute(skillAttribute: number, index: number) {
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkillAttribute(skillAttribute);
    const resp = await respPromise;
    if (resp.success) {
      vxm.users.removeUserAttributeDoc(skillAttribute);
      vxm.users.getProfileStrength();
      vm.$wlToastr('success', resp.successMessage, vm.$t('skill.success.message.title'));
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('skill.success.message.title'));
    }
  }

  async deleteSkillAttributeDoc(documentResponse: DocumentResponse) {
    console.log(
      'skill details - skillAttributenumber:' +
        documentResponse.userAttributeId +
        ' documentId:' +
        documentResponse.documentId,
    );
    const vm = this;
    const respPromise: any =
      vxm.skills.deleteSkillAttributeDoc(documentResponse);
    const resp = await respPromise;
    if (resp.success) {
      vxm.users.removeUserAttributeDoc(documentResponse.userAttributeId);
      vxm.users.getProfileStrength();
      vm.$wlToastr('success', resp.successMessage, vm.$t('skill.success.message.title'));
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('skill.success.message.title'));
    }
  }

  public transformDate(dttm: number): string {
    if (dttm === null) return '';
    const locale = vxm.users.getUserLang || 'en';
    return moment(dttm).locale(locale).format(this.getCompanyDateFormat.toUpperCase());
  }

  saveSkillDetailsMain() {
    console.log(
      'effective date:' +
        this.skillDocument.effectiveDTTMText +
        ' expiry date:' +
        this.skillDocument.expiryDTTMText,
    );

    const skillTypes = this.selectedUserAttrSkillWrapper.skillTypeList;
    const uID = this.selectedUserAttrSkillWrapper.userAttribute.userAttributeID;

    const vm = this;

    const file = this.skillDocument.userAttrDoc; //this.userAttrDoc;

    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );

    if (!this.isDropBoxFileUploaded) {
      if (!this.editMode) {
        if (!file) {
          this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('skill.success.message.title'));
          return;
        }
      }
      if (file && file.size > this.supportedFileSize) {
        this.$wlToastr(
          'error',
          this.$t('License_FileSizeRestriction', {
            maxSize: this.supportedFileSize / (1024 * 1024),
          }),
          this.$t('skill.success.message.title'),
        );
        return;
      }

      // if (!this.skillDocTypeMatches()) {
      //   this.$wlToastr(
      //     'error',
      //     'File type Not supported. Upload ' + allowedResumeFormat,
      //     this.$t('skill.success.message.title'),
      //   );
      //   return;
      // }
    }

    if (
      (this.effectiveDTTMFlag || this.documentExpires) &&
      this.skillDocument.effectiveDTTMText === undefined
    ) {
      this.$wlToastr('error', this.$t('License_EnterEffectiveDate'), this.$t('skill.success.message.title'));
      return;
    }
    if (
      (this.expiryDTTMFlag || this.documentExpires) &&
      this.skillDocument.expiryDTTMText === undefined
    ) {
      this.$wlToastr('error', this.$t('License_EnterExpiryDate'), this.$t('skill.success.message.title'));
      return;
    }
    if (
      this.licenseStateFlag &&
      this.isCredentialingEnabled &&
      !this.skillDocLicenceState
    ) {
      this.$wlToastr('error', this.$t('SkillsDetails_EnterLicenseState'), this.$t('skill.success.message.title'));
      return;
    }
    if (
      this.licenseNumberFlag &&
      this.isCredentialingEnabled &&
      !this.skillDocLicenceNumber
    ) {
      this.$wlToastr('error', this.$t('SkillsDetails_EnterLicenseNumber'), this.$t('skill.success.message.title'));
      return;
    }

    if (this.documentDoesNotExpire && !this.expiryDTTMFlag) {
      this.skillDocument.expiryDTTMText = '';
    }

    if (this.skillDocument.effectiveDTTMText) {
      this.skillDocument.effetiveDTTM = this.$moment(
        this.skillDocument.effectiveDTTMText,
      )
        .startOf('day')
        ._d.getTime();
    } else {
      this.skillDocument.effetiveDTTM = null;
    }
    if (this.skillDocument.expiryDTTMText) {
      this.skillDocument.expiryDTTM = this.$moment(
        this.skillDocument.expiryDTTMText,
      )
        .startOf('day')
        ._d.getTime();
    } else {
      this.skillDocument.expiryDTTM = null;
    }

    console.log(
      'this.skillDocument.startDTTMText:' +
        this.skillDocument.effectiveDTTMText,
    );
    console.log(
      'this.skillDocument.startDTTM:' + this.skillDocument.effetiveDTTM,
    );
    console.log(
      'this.skillDocument.endDTTMText:' + this.skillDocument.expiryDTTMText,
    );
    console.log(
      'this.skillDocument.expiryDTTM:' + this.skillDocument.expiryDTTM,
    );

    if (
      (!this.documentDoesNotExpire ||
        (this.effectiveDTTMFlag && this.expiryDTTMFlag)) &&
      this.skillDocument.effetiveDTTM &&
      this.skillDocument.expiryDTTM &&
      this.skillDocument.effetiveDTTM >= this.skillDocument.expiryDTTM
    ) {
      this.$wlToastr('error', this.$t('document-expire-err-msg'), this.$t('skill.success.message.title'));
      return;
    }

    this.effectiveDateStr = this.skillDocument.effectiveDTTMText;
    this.documentPayload.licenseState = this.skillDocLicenceState;
    this.documentPayload.licenseNumber = this.skillDocLicenceNumber;
    if (file !== undefined && file !== null) {
      if (file.name.length > 250) {
        this.$wlToastr(
          'error',
          this.$t('License_FileNameRestriction'),
          this.$t('skill.success.message.title'),
        );
        return;
      }

      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM
        ? this.skillDocument.effetiveDTTM.toString()
        : '';
      this.documentPayload.expiryDate = this.skillDocument.expiryDTTM
        ? this.skillDocument.expiryDTTM.toString()
        : '';
      this.documentPayload.documentName = file.name;
      this.documentPayload.documentFile = file;
      this.documentPayload.uid = uID;
      this.documentPayload.documentId = this.selectedDocument.documentId;
      /*skillTypes.forEach((value) => {
        this.documentPayload.document.documentName = '{"userAttributeId": ' +uID +',"skillTypeId": ' +value.skillTypeId +'}';
        const respPromise: any = vxm.skills.uploadSkillDocument(this.documentPayload,);
        Promise.all([respPromise]).then((values) => {
          console.log('successfully uploaded doc' + values[0]);
          if (values[0].success) {
            vxm.users.getProfileStrength();
          }
        });
      });*/
      this.documentPayload.document.documentName =
        '{"userAttributeId": ' +
        uID +
        ',"skillTypeId": ' +
        skillTypes[0].skillTypeId +
        '}';

      let respPromise: any;
      if (this.isDropBoxFileUploaded) {
        this.documentPayload.documentFile = this.dropBoxFile;
        respPromise = vxm.skills.uploadViaDropbox(this.documentPayload);
      } else {
        respPromise = vxm.skills.uploadSkillDocument(this.documentPayload);
      }
      Promise.all([respPromise]).then(async (values) => {
        this.isDropBoxFileUploaded = false;
        this.dropBoxFile = '';
        this.dropBoxFileName = '';
        console.log('successfully uploaded doc' + values[0]);
        if (values[0].success) {
          vxm.users.getProfileStrength();
          await vxm.users.getUserProfileAndNavigateTo('Skills');
          vxm.users.getSkills();
          vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
        } else {
          vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('skill.success.message.title'));
        }
      });
      this.skillDocument = new SkillDocument();
      this.selectedDocument = new DocumentResponse();
    } else {
      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM
        ? this.skillDocument.effetiveDTTM.toString()
        : null;
      this.documentPayload.expiryDate = this.skillDocument.expiryDTTM
        ? this.skillDocument.expiryDTTM.toString()
        : null;
      this.documentPayload.uid = uID;
      this.documentPayload.documentId = this.selectedDocument.documentId;
      this.documentPayload.document.documentName =
        '{"userAttributeId": ' +
        uID +
        ',"skillTypeId": ' +
        skillTypes[0].skillTypeId +
        '}';
      let respPromise: any;

      if (this.isDropBoxFileUploaded) {
        this.documentPayload.documentFile = this.dropBoxFile;
        respPromise = vxm.skills.uploadViaDropbox(this.documentPayload);
      } else {
        respPromise = vxm.skills.uploadSkillDocument(this.documentPayload);
      }

      Promise.all([respPromise]).then(async (values) => {
        console.log('successfully uploaded doc' + values[0]);
        this.isDropBoxFileUploaded = false;
        this.dropBoxFile = '';
        this.dropBoxFileName = '';
        if (values[0].success) {
          vxm.users.getProfileStrength();
          await vxm.users.getUserProfileAndNavigateTo('Skills');
          vxm.users.getSkills();
          vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
        } else {
          vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('skill.success.message.title'));
        }
      });
      /*skillTypes.forEach((value) => {this.documentPayload.document.documentName ='{"userAttributeId": ' +uID +',"skillTypeId": ' +value.skillTypeId +'}';
        const respPromise: any = vxm.skills.uploadSkillDocument(this.documentPayload,);
        Promise.all([respPromise]).then((values) => {
          console.log('successfully uploaded doc' + values[0]);
          if (values[0].success) {
            vxm.users.getProfileStrength();
          }
        });
      });*/
      this.skillDocument = new SkillDocument();
      this.selectedDocument = new DocumentResponse();
      this.editMode = false;
      this.documentDoesNotExpire = false;
    }

    this.uploadDocument = false;
    //vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
  }

  saveSkillDetailsEdit(skillTypeId: number, userAttributeID: number) {
    const skillWrapperArr = this.userAttrSkillWrappers.filter((doc) => {
      return doc.userAttribute.userAttributeID == userAttributeID;
    });

    const vm = this;
    const file = this.skillSearchUploadDocument.userAttrDoc;
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );

    if (!this.isUserAttributeUploadedForSkill(skillTypeId, userAttributeID)) {
      if (!file) {
        this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('skill.success.message.title'));
        return;
      }
    }
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('License_FileSizeRestriction', {
          maxSize: this.supportedFileSize / (1024 * 1024),
        }),
        this.$t('skill.success.message.title'),
      );
      return;
    }
    // if (!this.skillDocTypeMatches()) {
    //   this.$wlToastr(
    //     'error',
    //     'File type not supported. Upload ' + allowedResumeFormat,
    //     'Skills',
    //   );
    //   return;
    // }
    if (
      this.skillDocument.expiryDTTMText &&
      this.documentDoesNotExpire &&
      this.skillDocument.effectiveDTTMText === undefined
    ) {
      this.$wlToastr('error', this.$t('License_EnterEffectiveDate'), this.$t('skill.success.message.title'));
      return;
    }

    this.skillDocument.effetiveDTTM = this.$moment(
      this.skillDocument.effectiveDTTMText,
    )
      .startOf('day')
      ._d.getTime();
    this.skillDocument.expiryDTTM = this.$moment(
      this.skillDocument.expiryDTTMText,
    )
      .startOf('day')
      ._d.getTime();

    console.log(
      'this.skillDocument.startDTTMText:' +
        this.skillDocument.effectiveDTTMText,
    );
    console.log(
      'this.skillDocument.startDTTM:' + this.skillDocument.effetiveDTTM,
    );
    console.log(
      'this.skillDocument.endDTTMText:' + this.skillDocument.expiryDTTMText,
    );
    console.log(
      'this.skillDocument.expiryDTTM:' + this.skillDocument.expiryDTTM,
    );

    if (this.skillDocument.effetiveDTTM >= this.skillDocument.expiryDTTM) {
      this.$wlToastr('error', this.$t('document-expire-err-msg'), this.$t('skill.success.message.title'));
      return;
    }
    if (file !== undefined && file !== null) {
      this.documentPayload.documentName = file.name;
      this.documentPayload.documentFile = file;
      this.documentPayload.uid = userAttributeID;
      this.documentPayload.effectiveDate =
        this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate =
        this.skillDocument.expiryDTTM.toString();

      skillWrapperArr[0].skillTypeList.forEach((value) => {
        this.documentPayload.document.documentName =
          '{"userAttributeId": ' +
          userAttributeID +
          ',"skillTypeId": ' +
          value.skillTypeId +
          '}';
        console.log(
          'UID:' + userAttributeID + ' skilltypeId:' + value.skillTypeId,
        );
        const respPromise: any = vxm.skills.uploadSkillDocument(
          this.documentPayload,
        );
        Promise.all([respPromise]).then((values) => {
          console.log('successfully uploaded doc' + values[0]);
          if (values[0].success) {
            vxm.users.getProfileStrength();
          }
        });
      });
    } else {
      this.documentPayload.effectiveDate =
        this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate =
        this.skillDocument.expiryDTTM.toString();
      this.documentPayload.uid = userAttributeID;
      skillWrapperArr[0].skillTypeList.forEach((value) => {
        this.documentPayload.document.documentName =
          '{"userAttributeId": ' +
          userAttributeID +
          ',"skillTypeId": ' +
          value.skillTypeId +
          '}';
        const respPromise: any = vxm.skills.uploadSkillDocument(
          this.documentPayload,
        );
        Promise.all([respPromise]).then((values) => {
          console.log('successfully uploaded doc' + values[0]);
          if (values[0].success) {
            vxm.users.getProfileStrength();
          }
        });
      });
      this.skillDocument = new SkillDocument();
    }
    this.showModalEdit = false;
    vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
    //  $('#skillSearchModalScrollable').modal('hide');
  }

  async selectFromDropbox(userAttributeID: number, documentId: number) {
    console.log('documentid :' + documentId);
    const vm = this;
    vm.documentPayload.uid = userAttributeID;
    vm.documentPayload.documentId = documentId;
    vxm.skills
      .uploadDropboxAttributeFile(vm.documentPayload)
      .then(async (status: string) => {
        console.log('STATUS: select from Dropbox ', status);
        if (!!status) {
          this.isDropBoxFileUploaded = true;
          this.dropBoxFile = status;
          this.dropBoxFileName = decodeURI(this.dropBoxFile);
          this.dropBoxFileName = this.dropBoxFileName.split('\\').pop();
          this.dropBoxFileName =
            this.dropBoxFileName && this.dropBoxFileName.length > 0
              ? this.dropBoxFileName.split('/').pop()
              : this.dropBoxFileName;
        } else {
          this.isDropBoxFileUploaded = false;
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('SkillsDetails_DocumentUpload'));
      });
  }

  async selectFromDropbox_original(
    userAttributeID: number,
    documentId: number,
  ) {
    console.log('documentid :' + documentId);
    const vm = this;
    vm.documentPayload.uid = userAttributeID;
    vm.documentPayload.documentId = documentId;
    vxm.skills
      .uploadDropboxAttribute(vm.documentPayload)
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr('success', vm.$t('SkillsDetails_SuccessfullyUploaded'), vm.$t('skill.success.message.title'));
          vxm.users.getProfileStrength();
          await vxm.users.getUserProfileAndNavigateTo('Skills');
          vxm.users.getSkills();
        } else {
          vm.$wlToastr('info', vm.$t('SkillsDetails_CancelUpload'), vm.$t('skill.success.message.title'));
        }
      })
      .catch((err) => {
        vm.$wlToastr(
          'error',
          vm.$t('ResumeDetails_UploadResumeError'),
          vm.$t('ResumeDetails_UploadResume'),
        );
      });
  }

  async previewDocument(docGUID) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + docGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to preview document');
      }

      // Open the document in a new tab
      window.open(response.url, '_blank');
    } catch (error) {
      console.error('Error previewing document:', error);
    }
  }

  replaceUploadedDoc() {
    this.replaceUploadedDocument = !this.replaceUploadedDocument;
  }

  cancelSaveSkillMain() {
    this.replaceUploadedDocument = false;
    //this.showModal = false;
    this.uploadDocument = false;
    this.isDropBoxFileUploaded = false;
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
  }

  replaceUploadedDocEdit() {
    this.replaceUploadedDocumentEdit = !this.replaceUploadedDocumentEdit;
  }

  cancelSaveSkillEdit() {
    this.replaceUploadedDocumentEdit = false;
    this.showModalEdit = false;
  }

  isNotNull(val: any) {
    if (val == null || val === null || val == 'null') return false;
    else return true;
  }

  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate());
    dttm = result.getTime();
    var expDate = new Date(dttm);

    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }

  showModelDialog(editDelete: String) {
    if (editDelete === 'delete') {
      this.editDeleteHeader = this.$t('SkillsDetails_DeleteOptionNotAvailable').toString();
      this.editDeleteBody = this.$t('SkillsDetails_VerifiedDocumentCannotBeDeleted').toString();
    } else if (editDelete === 'edit') {
      this.editDeleteHeader = this.$t('SkillsDetails_EditOptionNotAvailable').toString();
      this.editDeleteBody = this.$t('SkillsDetails_VerifiedDocumentCannotBeEdited').toString();
    }
    this.$modal.show('verifieddocumentmodal');
  }

  hideModelDialog() {
    this.$modal.hide('verifieddocumentmodal');
  }
  skillDocTypeMatches(): boolean {
    if (!this.skillDocument.userAttrDoc) {
      return true;
    }
    const ext = this.skillDocument.userAttrDoc.name.match(/\.([^\.]+)$/)[1];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    console.log('ext::' + ext);
    console.log('allowedResumeFormat::' + allowedResumeFormat);
    return allowedResumeFormat.includes(ext.toLowerCase());
  }
}
